/* VialArt / VialCase — interaction performance.
   Coalesces window.renderAll: the builder re-renders the full gallery
   (~39 tiles, a ~150ms task) after EVERY keystroke; fast typing stacks
   those tasks and any interaction landing mid-burst pays the price (INP).
   Now: an isolated call runs immediately (clicks stay instant), calls in
   a burst collapse into ONE trailing render after the burst pauses.
   Identical file ships to BOTH themes. */
(function () {
  /* NOTE: the input listeners captured the ORIGINAL renderAll reference at
     bind time — wrapping renderAll does nothing for keystrokes. renderAll
     resolves scheduleCards() at CALL time though, so the tile storm is
     intercepted there. The live preview + summary stay instant. */
  function wrap() {
    var orig = window.scheduleCards;
    if (typeof orig !== 'function') return false;
    if (orig.__coalesced) return true;
    var last = 0, t = null;
    function run() { last = Date.now(); t = null; try { orig(); } catch (e) {} }
    var f = function () {
      var now = Date.now();
      if (!t && now - last > 600) { run(); return; }   // isolated call: instant
      if (t) clearTimeout(t);
      t = setTimeout(function () { requestAnimationFrame(run); }, 320);
    };
    f.__coalesced = 1;
    window.scheduleCards = f;
    return true;
  }
  var n = 0;
  (function tick() { if (wrap() || n++ > 40) return; setTimeout(tick, 250); })();
})();
